import { Radio } from 'antd'
import React from 'react'

function BasicRadio() {
  return (
    <Radio className='auf-radio'>Radio</Radio>
  )
}

export default BasicRadio